import homeTpl from './views/report-card-console.html';
import homeCtrl from './controllers/reportcardController';
var module = angular.module('reportCardGenConsoleModule', [
    //import modules
]).controller('reportCardGenConsole', homeCtrl);;

// import './manageReportsModule.scss';
// import templateProperty from './views/subject-property.html';
//import homeFctr from './services/homeFactory';
//import userSrv from './services/userService'

//module.service('homeFactory', homeFctr);
//module.service('userService', userSrv);


// module.config(function($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('reportCardGenConsole', {
//             parent: 'app',
//             url: '/report-card-gen-console/:cardId/:dataId/:re_generate/:fromCt',
//             views: {
//                 '@': {
//                     template: homeTpl,
//                     controller: homeCtrl,
//                     controllerAs: 'reportCardGenConsoleCtrl'
//                 }
//             }
//         })

// });





// WEBPACK FOOTER //
// ./src/app/report_cards/teacher/generation/reportgenerationModule.js